<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <menu-wrapper>
          <template #menu-button="{ toggleMenu }">
            <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
              <div :class="['icon20', nativeFilterIconClass]" :title="tooltipIcon"></div>
            </button>
          </template>
          <template #menu-content>
            <template v-for="(item, i) in filterOperators" :key="i">
              <menu-item
                class="filter-operator-item"
                :class="item.enumValue === operatorValue ? 'active' : ''"
                @menu-item-click="filterOperatorItemClick(item)"
                :icon="['icon24', item.icon]"
                >{{ item?.enumText }}</menu-item
              >
            </template>
          </template>
        </menu-wrapper>
      </ms-validate>
    </div>

    <div class="filter-value flex">
      <ms-datepicker
        ref="filterInput"
        :readOnly="operatorValueReadonly"
        class="datepicker w-full ms-input-filter-value"
        placeholder=""
        @keydown.enter="filterHeaderHandle({ operator: operatorValue, value: filterValue })"
        @msChange="val => filterHeaderHandle({ operator: operatorValue, value: val })"
        @keydown.stop=""
        v-model="filterValue"
        :hasTimeInfo="true"
        :format="'HH:mm:ss'"
        :hasBorder="false"
        :isFilterGrid="true"
        :showIconDate="false"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  extends: msThOptionBase,
  components: { msValidate, MenuItem, MenuWrapper },
  name: 'MsThOptionDate',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, { emit }) {
    //Variable
    const {
      nativeFilterIconClass,
      tooltipIcon,
      filterValue,
      filterInput,
      operatorValueReadonly,
      operatorValue,
      filterHeaderHandle,
      filterOperators,
      filterOperatorItemClick,
      removeFilter,
    } = setup(props, { emit });
    return {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterInput,
      operatorValueReadonly,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      tooltipIcon,
    };
  },
});
</script>
